{
  "wallboard": {
    "instances_count": "sem instâncias | {count} instância | {count} instâncias",
    "label": "Wallboard"
  }
}
